// extracted by mini-css-extract-plugin
module.exports = {"heading":"group-results__styles__heading--2Lnr4TKw","subheading":"group-results__styles__subheading--2pOm7vbw"};